import { Phone, MessageCircle, Facebook, Instagram, ArrowUpRight } from "lucide-react";
import {
    PHONE,
    WHATSAPP_URL,
    FACEBOOK_URL,
    INSTAGRAM_URL,
    MERO_URL,
    NAV_LINKS,
} from "../../data/site";
import { scrollToId } from "../../hooks/useLenis";

const socials = [
    { icon: Phone, href: `tel:${PHONE.raw}`, label: "Telefon" },
    { icon: MessageCircle, href: WHATSAPP_URL, label: "WhatsApp" },
    { icon: Facebook, href: FACEBOOK_URL, label: "Facebook" },
    { icon: Instagram, href: INSTAGRAM_URL, label: "Instagram" },
];

const quickLinks = NAV_LINKS.filter((l) =>
    ["hero", "servicii", "galerie", "locatie", "contact"].includes(l.target),
);

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="relative overflow-hidden bg-black pt-20 text-white">
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="grid grid-cols-1 gap-12 border-b border-white/10 pb-14 md:grid-cols-12">
                    <div className="md:col-span-6">
                        <h3 className="font-display text-3xl font-semibold tracking-tight">
                            GAN<span className="text-gold">.</span> BARBERSHOP
                        </h3>
                        <p className="mt-4 max-w-sm font-body text-neutral-400">
                            Stilul începe cu o tunsoare impecabilă. Programează-te
                            telefonic și trăiește experiența premium.
                        </p>
                        <div className="mt-6 flex gap-3">
                            {socials.map((s) => (
                                <a
                                    key={s.label}
                                    href={s.href}
                                    target={s.href.startsWith("http") ? "_blank" : undefined}
                                    rel="noopener noreferrer"
                                    aria-label={s.label}
                                    data-testid={`footer-social-${s.label}`}
                                    className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-neutral-300 transition-colors duration-300 hover:border-gold hover:text-gold"
                                >
                                    <s.icon size={17} strokeWidth={1.5} />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <span className="kicker text-neutral-500">Link-uri rapide</span>
                        <ul className="mt-6 flex flex-col gap-3">
                            {quickLinks.map((l) => (
                                <li key={l.target}>
                                    <button
                                        data-testid={`footer-link-${l.target}`}
                                        onClick={() => scrollToId(l.target)}
                                        className="font-body text-neutral-400 transition-colors duration-300 hover:text-gold"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <span className="kicker text-neutral-500">Programări</span>
                        <p className="mt-6 font-body text-neutral-400">
                            Telefonic:
                        </p>
                        <a
                            href={`tel:${PHONE.raw}`}
                            data-testid="footer-call-btn"
                            className="mt-2 inline-block font-display text-xl text-white transition-colors duration-300 hover:text-gold"
                        >
                            {PHONE.display}
                        </a>
                        <a
                            href={MERO_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-mero-btn"
                            className="mt-4 inline-flex items-center gap-1.5 font-body text-sm text-neutral-400 transition-colors duration-300 hover:text-gold"
                        >
                            Rezervă online pe MERO
                            <ArrowUpRight size={14} />
                        </a>
                    </div>
                </div>

                {/* Massive brand typography */}
                <div className="overflow-hidden py-8 text-center md:py-10">
                    <span className="block select-none bg-gradient-to-b from-neutral-500 to-neutral-900 bg-clip-text font-display text-[13vw] font-semibold leading-[0.9] tracking-tighter text-transparent md:whitespace-nowrap md:text-[8vw]">
                        <span className="block md:inline">GAN</span>{" "}
                        <span className="block md:inline">BARBERSHOP</span>
                    </span>
                </div>

                <div className="flex flex-col items-center justify-between gap-3 border-t border-white/10 py-8 text-center md:flex-row md:text-left">
                    <p className="font-body text-sm text-neutral-500">
                        © {new Date().getFullYear()} GAN BARBERSHOP. Toate drepturile rezervate.
                    </p>
                    <p
                        data-testid="footer-credit"
                        className="font-body text-sm text-neutral-500"
                    >
                        Made by{" "}
                        <span className="font-medium tracking-wide text-gold">
                            solstef
                        </span>
                    </p>
                </div>
            </div>
        </footer>
    );
};
